var down = "https://shopfront-cdn.tekoapis.com/static/06a44350362fc960.svg";

export { down as default };
